import axios, { AxiosRequestConfig } from 'axios'
import { isNil } from 'lodash'
import { ReadUserWalletsRequestDto, ReadUserWalletsResponseDto } from '@sparling/financial-common'

export const fetchUserWallets = async (
  { token, userIdSf, ...params }: ReadUserWalletsRequestDto & { token: string; userIdSf: string },
  options: AxiosRequestConfig = {},
): Promise<ReadUserWalletsResponseDto> => {
  // eslint-disable-next-line
  const { idSf, count, ...restParams } = params as any

  const response = await axios.get<ReadUserWalletsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/user/${userIdSf}/wallets`,
    {
      params: Object.fromEntries(Object.entries(restParams).filter(([, value]) => !isNil(value) && value !== '')),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}
